/**
 * Hash deep-linking for Instant page-builder pages.
 *
 * Instant has no built-in way to deep-link to a section from a URL hash, but it
 * does let you add a custom CSS class to an element. Add a class of the form
 * `kpst-<name>` (KindPatches Scroll To) to an Instant container, then link to
 * that page with `#kpst-<name>` and this scrolls there on load.
 *
 * The `kpst-` namespace keeps these anchors from colliding with normal #hashes
 * or third-party app classes. Full class === the URL hash, e.g.
 *   class="kpst-reviews"  ->  /pages/example#kpst-reviews
 */
(function () {
  var PREFIX = 'kpst-';
  var HEADER_OFFSET = 100; // px — keeps the target clear of the sticky header

  function init() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    var targetClass = decodeURIComponent(hash.slice(1));
    // Only act on our namespaced anchor classes.
    if (targetClass.indexOf(PREFIX) !== 0) return;

    var containers = document.querySelectorAll('[data-instant-type="container"]');
    if (!containers.length) return;

    var target = null;
    for (var i = 0; i < containers.length; i++) {
      if (containers[i].classList.contains(targetClass)) {
        target = containers[i];
        break;
      }
    }
    if (!target) return;

    var top = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: top, left: 0 });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
